export default __webpack_public_path__ + "files/FP12_General_Recommendations.docx";